import { Stack, Typography, styled } from '@planne-software/uni/mui/material';

export const PopoverInner = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.tokens.spacing['spacing-mini'],
  padding: theme.tokens.spacing['spacing-xs'],
}));

export const SectionBlock = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.tokens.spacing['spacing-1xmini'],
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-md-medium'],
  color: theme.tokens.colors['text-color-neutral-stronger'],
}));

export const UnavailableMessage = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-sm-regular'],
  color: theme.tokens.colors['text-color-alert-stronger'],
}));

export const TriggerValue = styled('span')(({ theme }) => ({
  ...theme.typography['text-sm-medium'],
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));
